import React from "react";
import { QuickStakeChips } from "@/features/betslip/components/parts/QuickStakeChips";
import { rounded } from "@/utilities/exoticStake";

type ComboQuickStakeChipsProps = {
  isOpen: boolean;
  activeInput: "total" | "perCombo" | null;
  totalCents: number;
  perComboCents: number;
  onSetTotalCents: (cents: number) => void;
  onSetPerComboCents: (cents: number) => void;
  isPromo: boolean;
  maxPromoStakeCents: number;
};

// Increments follow the focused field; Bal always fills the total, since the
// balance caps the bet as a whole.
export const ComboQuickStakeChips = ({
  isOpen,
  activeInput,
  totalCents,
  perComboCents,
  onSetTotalCents,
  onSetPerComboCents,
  isPromo,
  maxPromoStakeCents,
}: ComboQuickStakeChipsProps) => {
  const isPerCombo = activeInput === "perCombo";

  return (
    <QuickStakeChips
      isOpen={isOpen}
      valueCents={isPerCombo ? rounded(perComboCents, 0) : totalCents}
      onSetCents={isPerCombo ? onSetPerComboCents : onSetTotalCents}
      onSetBalanceCents={onSetTotalCents}
      isPromo={isPromo}
      maxPromoStakeCents={maxPromoStakeCents}
      arrowOffset={isPerCombo ? "calc(125%)" : "calc(-50%)"}
      detached
    />
  );
};
